import { useTheme } from "@mui/material";

export default function CloseIcon({ color, size = 18 }) {
  const theme = useTheme();
  const stroke = color || theme.palette.rgd.primary;

  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 1L1 17" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
      <path d="M17 17L1 1.00003" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}